import appGlobalScript from '/tmp/builds/5MRsrR2d8/1/TRUMPF-corp/trumpf-ux/features/integration-web-styleguide/src/boot.ts';
export const globalScripts = appGlobalScript;
